import React from "react";
import PropTypes from "prop-types";

/**
 * Khối section có icon + tiêu đề trong header bar riêng — gom field theo nhóm cho dễ
 * quét mắt (card + header nhẹ, giống FormSection của Payment Request). Dùng cho các
 * drawer tạo/sửa Purchase Requisition / Purchase Order thay vì thả field rời rạc.
 */
const FormSection = ({ icon, title, right, children, bodyClassName = "tw-p-4 sm:tw-p-5" }) => (
  <div className="tw-bg-geist-bg tw-rounded-geist-md tw-border tw-border-solid tw-border-geist-border tw-shadow-geist-card tw-overflow-hidden">
    <div className="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-px-4 sm:tw-px-5 tw-py-2.5 tw-border-b tw-border-solid tw-border-geist-border tw-bg-geist-bg-2">
      <div className="tw-flex tw-items-center tw-gap-2 tw-min-w-0">
        {icon && (
          <span className="tw-inline-flex tw-h-6 tw-w-6 tw-flex-shrink-0 tw-items-center tw-justify-center tw-rounded-sm tw-bg-geist-100 tw-text-geist-accent">
            <i className={`bi ${icon} tw-text-[12px]`} />
          </span>
        )}
        <h3 className="tw-text-[13px] tw-font-semibold tw-text-geist-fg tw-m-0 tw-truncate">{title}</h3>
      </div>
      {right}
    </div>
    <div className={bodyClassName}>{children}</div>
  </div>
);

FormSection.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.node,
  right: PropTypes.node,
  children: PropTypes.node,
  bodyClassName: PropTypes.string,
};

export default FormSection;
